//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  methods: {
    goBack: function () {
      this.$router.push({ path: "/home?hideTrans=true" });
    },
    goReturn() {
      this.$router.push({ path: "mine?hideTrans=true" });
    }
  },
  created() {
    this.book = this.$route.query;
    // 注意：原代码中recwordCateFirst方法未定义，若无需使用可注释或补充定义
    // this.recwordCateFirst(this.$route.query);
  },
  data() {
    return {
      url: "https://www.wordkillstu.com.cn",  // 补充url的默认值
      book: {},
      type: "1",
      totalUnitList: [],
      footer: {
        title: "1111",
        url: "http://vux.li",
      },
    };
  },
};



// WEBPACK FOOTER //
// ./src/views/publicView/me/gywm.vue